import { render, staticRenderFns } from "./salesman-detail.vue?vue&type=template&id=277e71f5&scoped=true"
import script from "./salesman-detail.vue?vue&type=script&lang=js"
export * from "./salesman-detail.vue?vue&type=script&lang=js"
import style0 from "./salesman-detail.vue?vue&type=style&index=0&id=277e71f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277e71f5",
  null
  
)

export default component.exports